"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgBookmark = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M30 31.057V17a1 1 0 00-1-1H19a1 1 0 00-1 1v14.057l5.419-3.87a1 1 0 011.162 0L30 31.056zm-6-1.828l-6.419 4.585A1 1 0 0116 33V17a3 3 0 013-3h10a3 3 0 013 3v16a1 1 0 01-1.581.814L24 29.229z",
    id: "bookmark_svg__a"
  }));
};

var _default = SvgBookmark;
exports.default = _default;